
import { storage, db } from "../../firebaseClient";
import { v4 as uuid } from 'uuid';
import type { AttachmentMeta } from "../types/attachments";

export async function uploadUnifiedFile(
  file: File,
  module: 'LAW_INFO' | 'GOV_PROJECT' | 'CONTRACT' | 'TEMPLATE' | 'OTHER',
  relatedId: string
): Promise<AttachmentMeta> {
  const id = uuid();
  const finalPath = file.type === 'application/pdf' 
      ? `docs/raw/${id}.pdf` 
      : `docs/raw/${id}_${file.name}`; 

  const storageRef = storage.ref(finalPath);

  // Upload to Storage
  const snapshot = await storageRef.put(file, { contentType: file.type });
  const downloadURL = await snapshot.ref.getDownloadURL();

  const now = new Date().toISOString();

  // Create attachment record in Firestore
  await db.collection('attachments').doc(id).set({
    module,
    relatedId,
    fileName: file.name,
    contentType: file.type,
    storagePath: finalPath,
    downloadURL: downloadURL, // Save URL for easier access
    textReady: false,
    createdAt: new Date() // Firestore timestamp
  });

  // Return standard AttachmentMeta for UI
  return {
    blobId: id, // Mapping ID to blobId for compatibility
    name: file.name,
    url: downloadURL,
    path: finalPath,
    contentType: file.type,
    size: file.size,
    uploadedAt: now
  };
}

export async function uploadUnifiedFiles(
  files: File[],
  module: 'LAW_INFO' | 'GOV_PROJECT' | 'CONTRACT' | 'TEMPLATE' | 'OTHER',
  relatedId: string
): Promise<AttachmentMeta[]> {
  const results: AttachmentMeta[] = [];
  for (const file of files) {
    const meta = await uploadUnifiedFile(file, module, relatedId);
    results.push(meta);
  }
  return results;
}
